
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqddYKsU1izNpti1nGIk1b3sCsoxvLXFcRbfdPu_45n162AMeta } from "/codebuild/output/src3483260001/src/src/pages/faq.vue?macro=true";
import { default as menuLAbi_45xTPN_YDKYejRY6B1SmKKcrclGc5syFK3XWNid8Meta } from "/codebuild/output/src3483260001/src/src/pages/menu.vue?macro=true";
import { default as index8eQ0G1ksV9eD7j8DahxYgoMoPC5F_45rfA4S1lQ451vL8Meta } from "/codebuild/output/src3483260001/src/src/pages/index.vue?macro=true";
import { default as contactWwIEYUC4MdOMRB8dyOYzPg_YHZ5thLB7n6fjF4ACtVYMeta } from "/codebuild/output/src3483260001/src/src/pages/contact.vue?macro=true";
import { default as tutorialRBKMIbW_PkMCfaJs3QsiBiF781pWx88HCfzjkVzXjNQMeta } from "/codebuild/output/src3483260001/src/src/pages/tutorial.vue?macro=true";
import { default as agreement_45SYIHxosjHR9O5WlMbOoL9QJUKTlegTflscYNJ6jmUMMeta } from "/codebuild/output/src3483260001/src/src/pages/agreement.vue?macro=true";
import { default as about_45passG__45Sh2FV_mnoLpsbKIZnzp861m5KObLREdgd2P6Qmd4Meta } from "/codebuild/output/src3483260001/src/src/pages/about-pass.vue?macro=true";
import { default as indexR_45QOyUlVm9cIN2uOPg5R5qfDf1nOeX9mUDOE5yFYdcMMeta } from "/codebuild/output/src3483260001/src/src/pages/card/index.vue?macro=true";
import { default as _91id_937GaYNsKEbxjwQlempCNjF589_45RmFJMymrVoL3Ta3cSQMeta } from "/codebuild/output/src3483260001/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceVW_s5ll_455ihlaoH5xdP3kQmK6dSonTu9itrHTP7pltoMeta } from "/codebuild/output/src3483260001/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93fwcsnkGXNi8NF0pvBHbTbrI3C2ywv3gTQ1SfPfCSMFcMeta } from "/codebuild/output/src3483260001/src/src/pages/notice/[id].vue?macro=true";
import { default as index_GvfStc_45Vqt6TpLImOKY8uJ_YPOqja3t1LNHYvFTRGsMeta } from "/codebuild/output/src3483260001/src/src/pages/coupon/index.vue?macro=true";
import { default as index2pjgXdYzdx5OlGp2vFVuOi3QCOSy9semak5_45cUQ2G7IMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/index.vue?macro=true";
import { default as indexjuBLH2y84OT3rRfFiIb_aAJvYNPK4IKn3ywfwIyHfjEMeta } from "/codebuild/output/src3483260001/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93DvJju8HZe5E2RcWe_DUv2Ss_pv4ISwgr6llsA_RcgnIMeta } from "/codebuild/output/src3483260001/src/src/pages/parking/[id].vue?macro=true";
import { default as indexH8MkM0Uh7yhJpFMQYy3zd0rO5HErFAuQWcroByKiAAgMeta } from "/codebuild/output/src3483260001/src/src/pages/history/index.vue?macro=true";
import { default as indextv_YAppghUR_YEeAHtu0hQaTfRjN3EuYXcWJGjVze38Meta } from "/codebuild/output/src3483260001/src/src/pages/monthly/index.vue?macro=true";
import { default as indexy6ZTy21LpqKTxlt03wKJd57vk05CtbAJXjVLoRLUor8Meta } from "/codebuild/output/src3483260001/src/src/pages/sign-in/index.vue?macro=true";
import { default as index2EhPQMQ7uGcAB57ROcmqet0219iYR_McfsRLdpZ0vVkMeta } from "/codebuild/output/src3483260001/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavixR2mU76442MEWItFz_Zxak_kogD6MjIi_45Lx0qmetkmMMeta } from "/codebuild/output/src3483260001/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editCgsBGpu6BCz6NSHzdFQjiLYiLRRXIB5mFpQ_45rUcgUB8Meta } from "/codebuild/output/src3483260001/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementd3Gdv5Jw_45mWMvuSLu00uVFMbpoo5HFmeKTS4dUTJlGYMeta } from "/codebuild/output/src3483260001/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexyFTlYOcMzHI_D_45fAffUn3ckkl836qgmw3gf3wcD08_EMeta } from "/codebuild/output/src3483260001/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dOjYwIzlQ1h_45gfuFHu_OMd51hRVoVQT0T6qtht46VFs8Meta } from "/codebuild/output/src3483260001/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmQf6v4dauaQKG6BGMa_uhs1zJBEyJMrrCCLYDZbqLnScMeta } from "/codebuild/output/src3483260001/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexZ0T0oXckQaqwWh5hWOm6Y3Wy5K72osk7aszdcB1cYt0Meta } from "/codebuild/output/src3483260001/src/src/pages/card/create/index.vue?macro=true";
import { default as index9CK_45xVGZQkXEiP7n_pmToqodb9HOVwXJoJGjOtkUlrEMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm5qSdK5RiGiYrxQCn90bkburNcwZMrWDW825r9OhmXbYMeta } from "/codebuild/output/src3483260001/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmhmSwPhHVlKpYVTQZbsmCrOPTq6NZld8XyFnahgr0Az4Meta } from "/codebuild/output/src3483260001/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completef_45PXHpAous_455w8Oj_45iZu8_4545eBlIernVehf1qsLL0RMMeta } from "/codebuild/output/src3483260001/src/src/pages/membership/complete.vue?macro=true";
import { default as registerzERXPIfQ_45WnVD2Wyxy98_45jqKnqqqbIuK70sF04OAd2QMeta } from "/codebuild/output/src3483260001/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93iT87wvGmnCvtLm4NEnHfM8YBeqwJ_5eBBERd1jwHoakMeta } from "/codebuild/output/src3483260001/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm730hu9HxFBj_7evYbBGsee2wIT7Q1Z9BHHATaJjHrXgMeta } from "/codebuild/output/src3483260001/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93uEfNaxX27WUj6MN3O06NB1cugZco5h9KIPiwd6g5bmMMeta } from "/codebuild/output/src3483260001/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexc4GK71WoXrGVVCzAjN5wzK51mdLR_etMCdIwRLwvtBUMeta } from "/codebuild/output/src3483260001/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeJ_7_45ejz2I3ovwVh_bvcuaqqzMr0lH5IE505i5oNUjx4Meta } from "/codebuild/output/src3483260001/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codezQnf562wSdugNwVbFFwZ4Xko2haYJKMSQGjWGck2uBUMeta } from "/codebuild/output/src3483260001/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete4FtYlrLy6C7tiVTQxTKhAuWukp_EJNnFxEv_45o9D3p_454Meta } from "/codebuild/output/src3483260001/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerjiogwtlYrOrJtEWLjxFDo5Cd53t4eE1yMoNaD4XHvmYMeta } from "/codebuild/output/src3483260001/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeaIgHg48Dkj8_tM2W0CYqO0TvteZx9s_45JPZHqa1RZaq4Meta } from "/codebuild/output/src3483260001/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexO6VGKPnWf1l9bJD_454TZHyD72SOb5nut8IE3qUSddcSQMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmK3jiX0IgnOlKtdHS1G6rhYAtT3ybv1eU7JKqrdsCwQ4Meta } from "/codebuild/output/src3483260001/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completetZdTCbcZQ5BiGNmF2ATCw1FQeyjPRcZLt_0iDFzr0eAMeta } from "/codebuild/output/src3483260001/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexWy1QISEbPrVuJBiK_45dVhafZTGMYjMrnplOcLc5fSQyEMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_937mPTNLhuMdOa_b_Ub1ew_45_45DRMUb_45tXrkNXsrUxoD0PIMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeqUOst88G3hdsocmkF_sJi0Z4PKclMU8YqhvKigXwrgcMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias43Ad4tB0uM8CgyCeTYJeKl9HW8bUlbh1ggS_45SEkcyYIMeta } from "/codebuild/output/src3483260001/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample8Ojfk7fyb7NMUltJJ3mShsj0L3Seowe__4q_45DFAVTpgMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailRZ7LInFQp6KEyJGAoc36FhgjvAIAnDLlu4yKDdaw8bAMeta } from "/codebuild/output/src3483260001/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmVUPSkORjTkKCok_dMY1Xp19R4Yw7k2gN54BNthLkHpAMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentzf3RX_45Z6TpNbe18rD82UzxdTPuyaC8ZuoDH5rmRhVQ8Meta } from "/codebuild/output/src3483260001/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmGtGPgMjM5bVT7FsMbz5Kdsg0_45vzqk2lWQODz5qAlvEYMeta } from "/codebuild/output/src3483260001/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateBYMNT_45vfImIRLpE1ncZMFDIxvdtMbQ3wVoxJiUUj0pAMeta } from "/codebuild/output/src3483260001/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeQ3RbWZm4i494LmE_45rYRuI5OAff6f_45A_45tfLcLonlV_45YcMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code9AH9CQchw5rZl6VcdS7W29llwOSaBNCCOAleyFTvOp0Meta } from "/codebuild/output/src3483260001/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordG_IwwWi2NZtHx7WxCBUhIPUbFKKPiXSdn6N2_IgmeAEMeta } from "/codebuild/output/src3483260001/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasuI8r2kW_Ee8Qe3qbfvrQBOZ7Vz2VR6FcN3XNGSWxarsMeta } from "/codebuild/output/src3483260001/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerNeai6FmxpBbmBkLW6rqYtzuSYVDnfOi_45e2ahb048bUcMeta } from "/codebuild/output/src3483260001/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeBG9uj9Eg0hPwAbj_M4D6IP3n4mjD4f0QudmDEBqZW5YMeta } from "/codebuild/output/src3483260001/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexSPIgBYYSRmcIIYyRHd5MeR79uGyyB78lVOe5msEUdIMMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexF7Whqj5s2qLarmv_45_TpzNaccDbslZZ_43CbgPB5dzccMeta } from "/codebuild/output/src3483260001/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexUnNj6B79WGmvzjlQ26wbRUwn5RLrCW08Js5dYk5UM3gMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index5XyysXG9eUXK_ZgmQArE6NGE6wMv_45oAw_9xQ635hMVYMeta } from "/codebuild/output/src3483260001/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatePKlodP12Dku7QnBB3c0bPBlM30_ZQb9viLvYsvb5Nw8Meta } from "/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeyV1gNPNM6FTy3LQSjxxMyJB0jDxxvNplt8eqYez7huQMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmmaccvjgfqYVVM_45nEodrYlN4wwlzOuRcSn_45D6VSJK94kMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexSaZBpTL91Odk8rLXgbmaYp5NLgQ_F18IRM4et_45w8HMQMeta } from "/codebuild/output/src3483260001/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completewEnmuK__cb_45JqjTSgAYKzdP1F28JwQmArfGXPIiiB4cMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update6VFhYjU3_45Lvc5P_fFRGDv6bD2GX04b5pdCuSl4_QaVwMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexYF5XOtYEXU2Qk9UWFBnOmNUJHNOccjjTtb1VJ2Ym7hAMeta } from "/codebuild/output/src3483260001/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexcKlPESefGJD9d6XZ9mwNosBEyJPJDOoQBUfdtkD921wMeta } from "/codebuild/output/src3483260001/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeznt5a4VvpmVTI9o0KpF4fZ_45O3GNubKoA41WRWlY5OhIMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexd2l8GHZ3Fwi3zJSEi85bOBD5wU3oqKtmbA33RQxX64QMeta } from "/codebuild/output/src3483260001/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codece_45mu3vokZmuDbDu_452D5bUObVrxWZwEyMnSosmv_45W28Meta } from "/codebuild/output/src3483260001/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index_J_VYcpdiOO6iO2sy1_45QhWIbzwZrTrDLQBpOo7_45_DaQMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexSPCGKCwE63_8OxzpdzdTyz8bSgLaKs4f2wfb7U6kWq4Meta } from "/codebuild/output/src3483260001/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexjmtS1mKWoHvOUVgKvUbvuyL0HxzVct9t9e6DlXZ8sysMeta } from "/codebuild/output/src3483260001/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateT_ElnSqWeWrIWmWnfcucp162Yhzo_45a3WslZdYTfatGEMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmWm0zsh3LmSIvtAR513yLnbp0dxT2NIXPuwIMZy6zlHoMeta } from "/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuLAbi_45xTPN_YDKYejRY6B1SmKKcrclGc5syFK3XWNid8Meta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index8eQ0G1ksV9eD7j8DahxYgoMoPC5F_45rfA4S1lQ451vL8Meta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index_GvfStc_45Vqt6TpLImOKY8uJ_YPOqja3t1LNHYvFTRGsMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3483260001/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexH8MkM0Uh7yhJpFMQYy3zd0rO5HErFAuQWcroByKiAAgMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3483260001/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexy6ZTy21LpqKTxlt03wKJd57vk05CtbAJXjVLoRLUor8Meta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index2EhPQMQ7uGcAB57ROcmqet0219iYR_McfsRLdpZ0vVkMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexZ0T0oXckQaqwWh5hWOm6Y3Wy5K72osk7aszdcB1cYt0Meta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm5qSdK5RiGiYrxQCn90bkburNcwZMrWDW825r9OhmXbYMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmhmSwPhHVlKpYVTQZbsmCrOPTq6NZld8XyFnahgr0Az4Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3483260001/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completef_45PXHpAous_455w8Oj_45iZu8_4545eBlIernVehf1qsLL0RMMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerzERXPIfQ_45WnVD2Wyxy98_45jqKnqqqbIuK70sF04OAd2QMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm730hu9HxFBj_7evYbBGsee2wIT7Q1Z9BHHATaJjHrXgMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeJ_7_45ejz2I3ovwVh_bvcuaqqzMr0lH5IE505i5oNUjx4Meta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codezQnf562wSdugNwVbFFwZ4Xko2haYJKMSQGjWGck2uBUMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete4FtYlrLy6C7tiVTQxTKhAuWukp_EJNnFxEv_45o9D3p_454Meta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerjiogwtlYrOrJtEWLjxFDo5Cd53t4eE1yMoNaD4XHvmYMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmK3jiX0IgnOlKtdHS1G6rhYAtT3ybv1eU7JKqrdsCwQ4Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completetZdTCbcZQ5BiGNmF2ATCw1FQeyjPRcZLt_0iDFzr0eAMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexWy1QISEbPrVuJBiK_45dVhafZTGMYjMrnplOcLc5fSQyEMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeqUOst88G3hdsocmkF_sJi0Z4PKclMU8YqhvKigXwrgcMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample8Ojfk7fyb7NMUltJJ3mShsj0L3Seowe__4q_45DFAVTpgMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailRZ7LInFQp6KEyJGAoc36FhgjvAIAnDLlu4yKDdaw8bAMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmVUPSkORjTkKCok_dMY1Xp19R4Yw7k2gN54BNthLkHpAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentzf3RX_45Z6TpNbe18rD82UzxdTPuyaC8ZuoDH5rmRhVQ8Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmGtGPgMjM5bVT7FsMbz5Kdsg0_45vzqk2lWQODz5qAlvEYMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeQ3RbWZm4i494LmE_45rYRuI5OAff6f_45A_45tfLcLonlV_45YcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code9AH9CQchw5rZl6VcdS7W29llwOSaBNCCOAleyFTvOp0Meta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordG_IwwWi2NZtHx7WxCBUhIPUbFKKPiXSdn6N2_IgmeAEMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerNeai6FmxpBbmBkLW6rqYtzuSYVDnfOi_45e2ahb048bUcMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeBG9uj9Eg0hPwAbj_M4D6IP3n4mjD4f0QudmDEBqZW5YMeta || {},
    component: () => import("/codebuild/output/src3483260001/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3483260001/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]